module.exports = __webpack_public_path__ + "img/smallmaso.b0f51b9f.jpg";